import * as React from 'react';

import {CopyIconButton} from '../button/copy-button/copy-icon-button';
import {useResizeObserver} from '../utils/hooks/use-resize-observer';

import {Link} from './link';

const COPY_BUTTON_OFFSET = 16;

type Props = {
    link: string;
    size?: 'big' | 'small';
    shouldTruncate?: boolean;
    buttonHasBorder?: boolean;
};

export function LinkWithCopyButton(props: Props) {
    const {size = 'big'} = props;

    const containerRef = React.useRef(null);
    const linkContainerRef = React.useRef(null);

    const [width] = useResizeObserver(containerRef.current);

    const [linkWidth, setLinkWidth] = React.useState<number | null | undefined>(null);

    React.useLayoutEffect(() => {
        if (linkContainerRef.current) {
            // @ts-expect-error
            setLinkWidth(linkContainerRef.current.clientWidth);
        }
    }, []);

    React.useEffect(() => {
        if (typeof width === 'number' && linkContainerRef.current) {
            setLinkWidth(
                // @ts-expect-error
                Math.min(width - COPY_BUTTON_OFFSET, linkContainerRef.current.clientWidth)
            );
        }
    }, [width]);

    return (
        <div className='flex align-center gap-4' ref={containerRef}>
            <div className='truncate' ref={linkContainerRef}>
                <Link
                    variant='secondary'
                    size={size}
                    newTab={true}
                    href={props.link}
                    onClick={(e) => e.stopPropagation()}
                    // @ts-expect-error
                    style={props.shouldTruncate ? {maxWidth: linkWidth} : {}}
                >
                    {props.link}
                </Link>
            </div>
            <CopyIconButton
                as='div'
                text={props.link}
                size={size}
                hasBorder={props.buttonHasBorder}
            />
        </div>
    );
}
